module.exports = __webpack_public_path__ + "static/media/Karl D.D. Willis.790460cf.png";